import { useEffect } from 'react';

export const useElementTitle = (ele: string, value: string) => {

  useEffect(() => {
    const ResEle = document.getElementsByTagName(ele)[0] as HTMLHeadingElement | HTMLAnchorElement;
    ResEle.title = value!;
  }, [ele, value]);

}